export enum SecondaryNavKey {
  Cfs,
  ManageAccount,
  Reporting,
  Diagnostics,
}
